/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import { Label } from 'semantic-ui-react';
import searchIcon from '../../images/components/contnets_header/searchIcon.png';
import deleteIcon from '../../images/components/contnets_header/delete-icon-red.svg';

class SettingContentsHeaderByResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errSearch: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleRemoveResult = this.handleRemoveResult.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleSearch(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
              });
            }, 1500);
          }
        );
        return false;
      }
      this.props.onChangeSearch(event.target.value);
    }
  }

  handleSearchChange(event) {
    const { handleSearchChange } = this.props;
    handleSearchChange(event.target.value);
  }

  handleRemoveResult() {
    const { handleRemoveResult } = this.props;
    handleRemoveResult();
  }

  clearSearch() {
    const { clearSearch } = this.props;
    this.search.value = '';
    clearSearch();
  }

  render() {
    const { errSearch } = this.state;
    const { translate, count } = this.props;
    return (
      <div className="contents_header">
        <div className="contents_header_inner">
          <h3 className="content_title">
            {translate('settings.list.defined_result')}
            <em>{count}</em>
          </h3>
          <div className="util_wrap">
            <div className="util_item ">
              <div className="search_files_wrap">
                <img src={searchIcon} alt="" className="icon" />
                <input
                  type="search_files"
                  className="seach_text"
                  placeholder={translate('contents_header.place_holder.scan_file_and_component')}
                  ref={(ref) => {
                    this.search = ref;
                  }}
                  onChange={this.handleSearchChange}
                  onKeyPress={this.handleSearch}
                />
                <a className="reset_icon" onClick={this.clearSearch}>
                  x
                </a>
                {errSearch && (
                  <Label basic color="red" pointing>
                    {translate('contents_header.message.least_two_required_to_search')}
                  </Label>
                )}
              </div>
            </div>
            <div className="button_wrap util_item">
              <a
                className="delete_button util_button"
                onClick={this.handleRemoveResult}
                style={{ cursor: 'pointer' }}
              >
                <span>
                  <img src={deleteIcon} alt="" style={{ width: '12px' }} />
                </span>
                {translate('modal.button.delete')}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SettingContentsHeaderByResult;
